import { useQuery } from 'react-query';
import { Navigate, useParams } from 'react-router-dom';

import feathersClient from '../../../../apiClient';
import Protect from '../../../../apiClient/Protect';
import Card from '../../../../components/Layout/Card';
import PhoneVerificationBadge from '../../../../components/PhoneVerificationBadge/PhoneVerificationBadge';
import SendVerifySignupButton from '../../../../components/SendVerifySignupButton/SendVerifySignupButton';
import { Roles } from '../../../../utils/enums';
import { getLatestPhone } from '../../../../utils/phoneNumber';

const UserContactList = () => {
  const { personId } = useParams();

  const { data: person } = useQuery(['person-contact', personId], async () =>
    feathersClient.service('person').get(personId!, {
      query: {
        $eager: '[contact, login]',
      },
    }), { enabled: !!personId });

  if (!personId) {
    return <Navigate to="/shift" />;
  }

  const personPhone = getLatestPhone(person?.contact);

  return (
    <Card>
      <div className="flex items-center gap-5">
        <h5 className="ty-h5">email:</h5>
        {person?.login?.username} <SendVerifySignupButton login={person?.login} />
      </div>
      <div className="flex items-center gap-5">
        <h5 className="ty-h5">mobil: </h5>
        {personPhone?.value}
        {personPhone?.value && (
          <Protect auth={[Roles.SUPER_ADMIN, Roles.TYMBE_ADMIN, Roles.TYMBE_COORDINATOR, Roles.ADMIN]} redirect={false}>
            <PhoneVerificationBadge contact={personPhone} />
          </Protect>
        )}
      </div>
    </Card>
  );
};

export default UserContactList;
